import React, { useEffect, useState } from "react";
import logo from "../assets/bsast.png";

function WelcomeBanner({ user }) {
  const [animate, setAnimate] = useState(false);
  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <div 
      className="d-flex justify-content-between align-items-center px-4 py-2 mb-3" 
      style={{ 
        backgroundColor: "#198754",
        color: "white",
        borderRadius: "0 0 8px 8px",
        transition: "all 0.5s ease"
      }}
    >
      <h2 
        className="mb-0"
        style={{
          opacity: animate ? 1 : 0,
          transform: animate ? "translateY(0)" : "translateY(-10px)",
          transition: "all 0.5s ease"
        }}
      >
        ETCS DMI Development portal
      </h2>
      <img 
        src={logo} 
        alt="Logo" 
        style={{ 
          height: "40px",
          borderRadius: "4px",
          transform: animate ? "scale(1)" : "scale(0)",
          transition: "transform 0.5s ease"
        }} 
      />
    </div>
  );
}

export default WelcomeBanner;
